import {
  Component,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  HostListener,
  Inject,
} from "@angular/core";
import { MessageService } from "src/app/injectable/message.service";
import { Sender } from "src/app/model/sender";
import { Category } from "src/app/model/category";
import { Area } from "src/app/model/area";
// import { JobZone, JobDistributionList } from 'src/app/model/job';
import { JobZone, Job, JobPoint, JobList } from "src/app/model/job";
import {
  NgForm,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { UploadResult } from "src/app/model/uploadResult";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { LatLngLiteral } from "@agm/core";
import { VariableService } from "src/app/shared/services/variable.service";
import { Coordinate } from "src/app/model/areaCoords";
import { MatOption } from "@angular/material/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FileValidator } from "ngx-material-file-input";
import { map } from "rxjs/operators";
import { of, Observable } from "rxjs";
import { Lista } from "src/app/model/lista";
import { DistributionListService } from "src/app/injectable/distribution-list.service";
import { DetailMapV2Component } from "../detail-map-v2/detail-map-v2.component";
import { OriginalMessage } from "src/app/model/OriginalMessage";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
// import { DistributionList } from 'src/app/model/distributionList';
// import { DistributionListService } from 'src/app/injectable/distribution-list.service';

export interface AcceptedFile {
  id: number;
  estensione: string;
  maxMB: number;
  tipo: string;
  mimeType: string;
}

@Component({
  selector: "app-new-message",
  templateUrl: "./new-message.component.html",
  styleUrls: ["./new-message.component.scss"],
})
export class NewMessageComponent implements OnInit {
  // profileForm = this.fb.group({
  //   firstName: ['', Validators.required],
  //   lastName: [''],
  //   address: this.fb.group({
  //     street: [''],
  //     city: [''],
  //     state: [''],
  //     zip: ['']
  //   }),
  // });
  public selectedMoment = new Date();

  @Output() messageSendSuccess: EventEmitter<any> = new EventEmitter();
  @ViewChild(DetailMapV2Component) agmMap: DetailMapV2Component;
  senders: Sender[];
  selectedSender: Sender;
  categories: any;
  language: any;
  logo: any;
  listaPrezzo: [] = [];
  aree: Area[] = undefined;
  areeToShow: Area[] = [];
  liste: Lista[] = undefined;
  listeDelSender: Lista[] = undefined;
  inizio: Date;
  scadenza: Date;
  sub = false;
  chosenSendingMode = "aree";
  fieldStillLoading = 0;
  panelOpenState = false;
  isFileNameIncorrect: boolean = false;
  mimesAllowed = "";
  acceptedFiles: Array<AcceptedFile> = [];
  jobForm = this.fb.group({
    sender: ["", Validators.required],
    category: ["", Validators.required],
    messageCore: this.fb.group({
      subject: [
        "",
        Validators.compose([Validators.maxLength(50), Validators.required]),
      ],
      body: [
        "",
        Validators.compose([Validators.maxLength(600), Validators.required]),
      ],
      file: [
        undefined,
        Validators.compose([
          FileValidator.maxContentSize(0),
          Validators.required,
        ]),
      ],
      link: [
        "",
        Validators.compose([
          Validators.maxLength(2000),
          Validators.pattern(
            "^(http://www.|https://www.|http://|https://)[a-z0-9]+([-.]{1}[a-z0-9]+)*.[a-z]{2,5}(:[0-9]{1,5})?(/.*)?$"
          ),
        ]),
      ],
    }),
    sendingMode: "aree",
    chatEnabled: 1,
    aree: [null, Validators.required],
    lista: null,
    times: this.fb.group({
      inizio: [new Date(), Validators.required],
      inizio_tempo: [
        new Date().getHours() + ":" + new Date().getMinutes(),
        Validators.required,
      ],
      scadenza: [new Date(), Validators.required],
      scadenza_tempo: ["23:59", Validators.required],
    }),
    idPrezzo: ["", Validators.required],
  });

  constructor(
    private messageService: MessageService,
    private distListService: DistributionListService,
    private translate: TranslateService,
    public dialog: MatDialog,
    public router: Router,
    protected sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private sharedVariable: VariableService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<NewMessageComponent>,
    private genericErrorModalService: GenericErrorModalService,
    @Inject(MAT_DIALOG_DATA) public data // public map: MapComponent, // public dlService: DistributionListService
  ) {}

  // @HostListener('window:keyup.esc') onKeyUp() {
  //   this.dialogRef.close();
  // }

  ngOnInit() {
    this.getMimesAccepted();
    this.senders = this.data.senders;
    this.jobForm.get("times").setValidators(dateValidator()); // setta il validator per i tempi
    this.jobForm.get("sendingMode").valueChanges.subscribe((sendingMode) => {
      if (sendingMode === "aree") {
        this.jobForm.get("aree").setValidators([Validators.required]);
        this.jobForm.get("lista").setValidators(null);
      }
      if (sendingMode === "lista") {
        this.jobForm.get("aree").setValidators(null);
        this.jobForm.get("lista").setValidators([Validators.required]);
      }
      this.jobForm.get("aree").updateValueAndValidity();
      this.jobForm.get("lista").updateValueAndValidity();
    });
    this.jobForm.get("aree").valueChanges.subscribe((areeToShow) => {
      if (areeToShow && this.aree)
        this.areeToShow = this.aree.filter((s) => areeToShow.includes(s.id));
      // this.areeToShow = this.aree.filter(s => areeToShow.includes(s.id));
      if (this.areeToShow.length == 0) this.panelOpenState = false;
      if (this.panelOpenState) this.agmMap.adjustBounds(this.areeToShow);
    });

    this.messageService.getListino().subscribe((data) => {
      this.listaPrezzo = data;
    });
  }

  getMimesAccepted() {
    this.messageService.getFileInfo().subscribe((data) => {
      let ret = [];
      data.forEach((element) => {
        this.acceptedFiles.push({
          mimeType: element["mimeType"],
          estensione: element["extension"],
          id: element["id"],
          maxMB: element["maxSizeMB"],
          tipo: element["type"],
        });
      });
      this.acceptedFiles.forEach((element) => {
        //ret += (element.tipo == "document" ? "application" : element.tipo) + "/" + element.estensione + ","
        ret.push(element.mimeType);
      });
      ret = ret.filter((item, index) => ret.indexOf(item) === index);
      this.mimesAllowed = ret.join(",").slice(0, -1);
    });
  }

  senderPrice(x: any) {
    this.jobForm.patchValue({
      idPrezzo: x,
    });
  }

  fileNotSupported = false;
  fileRequired = false;
  checkFile(file: File) {
    this.fileNotSupported = false;
    this.fileRequired = false;
    try {
      this.jobForm.controls["messageCore"]
        .get("file")
        .setValidators([
          FileValidator.maxContentSize(
            this.acceptedFiles.find(
              (x) => x.estensione == file.name.split(".").pop()
            ).maxMB *
              2 ** 20
          ),
          Validators.required,
        ]);
      this.jobForm.controls["messageCore"].get("file").updateValueAndValidity();
    } catch (e) {
      if (this.jobForm.get("file") == null) {
        this.fileRequired = true;
      } else {
        this.fileNotSupported = true;
      }
    }
  }

  senderSelected(selectedSender) {
    this.selectedSender = selectedSender;
    this.language = this.selectedSender.lang;
    this.logo = this.selectedSender.logo;
    this.aree = undefined;
    this.liste = undefined;
    this.categories = undefined;
    this.increaseFieldStillLoading();
    this.messageService.getCategoryList(this.selectedSender.id).subscribe(
      (categories: Category[]) => {
        if (categories.length == 1) {
          this.categories = categories;
        } else {
          this.categorySort(categories);
          this.categories = categories;
        }
        this.decreaseFieldStillLoading();
      },
      (err) => {
        this.decreaseFieldStillLoading();
        this.genericErrorModalService.open(
          "Errore nel caricamento delle categorie del Sender",
          err
        );
      }
    );
    this.increaseFieldStillLoading();
    this.messageService.getAreaList(this.selectedSender.id).subscribe(
      (aree: Area[]) => {
        if (aree.length == 1) {
          this.aree = aree;
        } else {
          this.areeSort(aree);
          this.aree = aree;
        }
        this.decreaseFieldStillLoading();
      },
      (err) => {
        this.decreaseFieldStillLoading();
        this.genericErrorModalService.open(
          "Errore nel caricamento delle aree del Sender",
          err
        );
      }
    );
    this.increaseFieldStillLoading();
    this.distListService.getDistributionLists().subscribe(
      (liste: Lista[]) => {
        this.listeDelSender = liste.filter(
          (s) => s.senderName == this.selectedSender.name
        );
        if (liste.length == 1) {
          this.liste = liste;
        } else {
          this.listeSort(liste);
          this.liste = liste;
        }
        this.decreaseFieldStillLoading();
      },
      (err) => {
        this.decreaseFieldStillLoading();
        this.genericErrorModalService.open(
          "Errore nel caricamento dei dettagli del Sender",
          err
        );
      }
    );
  }

  increaseFieldStillLoading() {
    this.fieldStillLoading = this.fieldStillLoading + 1;
  }

  decreaseFieldStillLoading() {
    this.fieldStillLoading = this.fieldStillLoading - 1;
  }

  onSubmit() {
    this.sub = true;
    this.markFormGroupTouched(this.jobForm);
    if (this.jobForm.invalid) {
      this.sub = false;
    }
    setTimeout(() => {
      if (this.jobForm.valid) {
        if (this.chosenSendingMode == "aree") {
          this.increaseFieldStillLoading();
          this.createJobZoneByArea().subscribe(
            (jobZone) => {
              this.messageService.createJobZone(jobZone).subscribe(
                (out) => {
                  if (out.message == "MES01" || out.message == "MES02") {
                    this.sub = false;
                    this.dialogRef.close("MES01");
                  }
                  this.decreaseFieldStillLoading();
                },
                (err) => {
                  this.decreaseFieldStillLoading();
                  this.sub = false;
                  this.dialogRef.close("ERR");
                }
              );
            },
            (error) => {
              if (
                error.error.message ==
                  "Multimedia con Extension=(ogg) e MimeType=(audio/ogg) non ammesso" &&
                error.error.errorCode == "ERR01"
              ) {
                this.decreaseFieldStillLoading();
                this.sub = false;
                alert("Per favore inserisci un file valido");
              }
            }
          );
        } else if (this.chosenSendingMode == "lista") {
          this.increaseFieldStillLoading();
          this.createJobZoneByList().subscribe((jobList) => {
            this.messageService.createJobList(jobList).subscribe(
              (out) => {
                if (out.message == "MES01" || out.message == "MES02") {
                  this.sub = false;
                  this.dialogRef.close("MES01");
                }
                this.decreaseFieldStillLoading();
              },
              (err) => {
                this.decreaseFieldStillLoading();
                this.sub = false;
                this.dialogRef.close("ERR");
              }
            );
          });
        }
      } else {
        this.sub = false;
      }
      // TODO: Use EventEmitter with form value
    }, 2000);
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach((control) => {
      control.updateValueAndValidity();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  createJobZoneByArea(): Observable<JobZone> {
    const jobZone: JobZone = new JobZone();
    jobZone.senderId = this.jobForm.value.sender.id;
    jobZone.categoryCode = this.jobForm.value.category;
    jobZone.originalMessages = new Array<OriginalMessage>();
    const originalMessage: OriginalMessage = new OriginalMessage();
    originalMessage.subject = this.jobForm.value.messageCore.subject;
    originalMessage.content = this.jobForm.value.messageCore.body;
    originalMessage.language = this.selectedSender.lang;
    jobZone.originalMessages.push(originalMessage);
    jobZone.url = this.jobForm.value.messageCore.link;
    jobZone.areaIds = this.jobForm.value.aree;
    const inizio: Date = new Date(this.jobForm.value.times.inizio);
    const scadenza: Date = new Date(this.jobForm.value.times.scadenza);
    const startTimePart = this.jobForm.value.times.inizio_tempo.split(":");
    inizio.setHours(Number(startTimePart[0]), Number(startTimePart[1]));
    const endTimePart = this.jobForm.value.times.scadenza_tempo.split(":");
    scadenza.setHours(Number(endTimePart[0]), Number(endTimePart[1]));
    jobZone.startDate = inizio;
    jobZone.endDate = scadenza;
    //INSERITO IL PREZZO
    jobZone.idPrezzo = this.jobForm.value.idPrezzo;

    ///////////////// File //////////////////////
    if (this.jobForm.value.messageCore.file) {
      // Se si vuole caricare anche un file
      return this.messageService
        .uploadMultimediaFile(
          this.jobForm.value.messageCore.file,
          this.jobForm.value.sender.id
        )
        .pipe(
          map((uploadResult: UploadResult) => {
            jobZone.multimediaFileRef = uploadResult.fileRef;
            return jobZone;
          })
        );
    } else {
      return of(jobZone);
    }
  }

  createJobZoneByList(): Observable<JobList> {
    const jobList: JobList = new JobList();
    jobList.senderId = this.jobForm.value.sender.id;
    jobList.categoryCode = this.jobForm.value.category;
    jobList.originalMessages = new Array<OriginalMessage>();
    const originalMessage = new OriginalMessage();
    originalMessage.language = this.selectedSender.lang;
    originalMessage.subject = this.jobForm.value.messageCore.subject;
    originalMessage.content = this.jobForm.value.messageCore.body;
    jobList.originalMessages.push(originalMessage);
    jobList.url = this.jobForm.value.messageCore.link;
    // jobList.areaIds = this.jobForm.value.aree;
    jobList.distListId = this.jobForm.value.lista;
    jobList.chatEnabled = this.jobForm.value.chatEnabled;
    const inizio: Date = new Date(this.jobForm.value.times.inizio);
    const scadenza: Date = new Date(this.jobForm.value.times.scadenza);
    const startTimePart = this.jobForm.value.times.inizio_tempo.split(":");
    inizio.setHours(Number(startTimePart[0]), Number(startTimePart[1]));
    const endTimePart = this.jobForm.value.times.scadenza_tempo.split(":");
    scadenza.setHours(Number(endTimePart[0]), Number(endTimePart[1]));
    jobList.startDate = inizio;
    jobList.endDate = scadenza;
    ///////////////// File //////////////////////
    if (this.jobForm.value.messageCore.file) {
      // Se si vuole caricare anche un file
      return this.messageService
        .uploadMultimediaFile(
          this.jobForm.value.messageCore.file,
          this.jobForm.value.sender.id
        )
        .pipe(
          map((uploadResult: UploadResult) => {
            jobList.multimediaFileRef = uploadResult.fileRef;
            return jobList;
          })
        );
    } else {
      return of(jobList);
    }
  }

  fileNameError(control: any) {
    this.isFileNameIncorrect = control.target.value.includes("..");
  }

  back() {
    this.router.navigate([""], { relativeTo: this.route });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  categorySort(categories) {
    categories.sort((a, b) => a.category.localeCompare(b.category));
  }

  areeSort(aree) {
    aree.sort((a, b) => a.area.localeCompare(b.area));
  }

  listeSort(liste) {
    liste.sort((a, b) => a.distListDTO.name.localeCompare(b.distListDTO.name));
  }

  changeSendingMode(value) {
    this.areeToShow = [];
    this.jobForm.patchValue({
      aree: this.areeToShow.map((item) => item.id),
    });
    this.chosenSendingMode = value;
  }

  setAreeAndListaErrorToNull() {
    // this.jobForm.get('aree').setErrors({'emptyTarget': null})
    // this.jobForm.get('lista').setErrors({'emptyTarget': null})
    // this.markFormGroupTouched(this.jobForm);
  }

  requiredTargetValidator(target: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (this.chosenSendingMode == target) {
        if (control.value == null || control.value.length == 0) {
          return {
            emptyTarget: true,
          };
        }
      } else {
        return null;
      }
    };
  }

  /** Ritorna lo stato del contratto.
   * 0 : tutto ok
   * 1 : contratto in scadenza  (a meno di 30 giorni dalla)
   * 2 : contratto scaduto
   */
  getContractStatus(sender): number {
    const date = new Date(sender.contractEndDate);
    const result = Math.floor(
      date.getTime() / 1000 - new Date().getTime() / 1000
    );
    if (result > 100 && result < 2600000) {
      // 2600000 sono i secondi i 30 giorni circa
      return 1;
    } else if (result <= 100) {
      return 2;
    } else {
      return 0;
    }
  }
}

export function dateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    ////// Setta i tempi //////
    const inizio: Date = new Date(control.value.inizio);
    const scadenza: Date = new Date(control.value.scadenza);
    const startTimePart = control.value.inizio_tempo.split(":");
    inizio.setHours(Number(startTimePart[0]), Number(startTimePart[1]));
    const endTimePart = control.value.scadenza_tempo.split(":");
    scadenza.setHours(Number(endTimePart[0]), Number(endTimePart[1]));
    ///////////////////////////
    if (inizio.getTime() - new Date().getTime() < -600000) {
      // almeno -10 minuti
      return {
        invalidStartDate: true,
      };
    }
    if (scadenza.getTime() - inizio.getTime() < 3600000) {
      // almeno un'ora
      return {
        invalidEndDate: true,
      };
    }
    return null;
  };
}
